import React from 'react';
import AttributeTypes from "../../../../Attributes/AttributeTypes";

function AttributeType(props) {
    const { dataItem, field, hidden } = props;
    const { Types } = AttributeTypes;

    const getTypeText = (type) => {
        const typeObj = Types.find(t => t.value === type);
        return typeObj ? typeObj.text : "";
    };

    const typeText = getTypeText(dataItem[field]);

    return (
        <td>
            <span className={hidden ? "text-muted" : ""}>
                {typeText}
            </span>
        </td>
    );
}

export default AttributeType;
